/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Hamburger20 = (props: SVGProps) => (
    <AccessibleSVG width={20} height={20} viewBox="0 0 20 20" {...props}>
        <path
            fill={vars.white}
            fillRule="evenodd"
            d="M19 15a1 1 0 010 2H1a1 1 0 010-2h18zm0-6a1 1 0 010 2H1a1 1 0 010-2h18zm0-6a1 1 0 010 2H1a1 1 0 110-2h18z"
        />
    </AccessibleSVG>
);

export default Hamburger20;
